import styled from "styled-components";

export const StyledButton = styled.a`
  font-family: "Poppins";
  font-weight: 600;
  background-color: #1db954;
  color: #fff;
`;
